import { clsx } from 'clsx';
import { format, parseISO } from 'date-fns';
import React from 'react';
import type { InvitationRead } from '../../../../../js/api/models/InvitationRead';

const CardHeading: React.FC<React.ComponentPropsWithoutRef<'p'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <p
      {...props}
      className={clsx(className, 'tw:!text-[16px] tw:font-semibold tw:text-zinc-900 tw:!mb-0')}
    >
      {children}
    </p>
  );
};

export const PendingInvitationCard: React.FC<{
  invitation: InvitationRead;
  groupNamesMap: Record<string, string>;
  isSelected?: boolean;
  actions?: React.ReactNode;
}> = ({ invitation, groupNamesMap, isSelected = false, actions }) => {
  const invitedOn = invitation.created_at
    ? format(parseISO(invitation.created_at), 'LLL d, yyyy')
    : '—';

  return (
    <div
      className={clsx(
        'tw:h-full tw:bg-white tw:rounded-lg tw:shadow-sm tw:border tw:border-zinc-200 tw:hover:shadow-md tw:hover:bg-muted tw:transition-shadow',
        isSelected && 'tw:!bg-brand-green-0/10 tw:!shadow-md'
      )}
    >
      <div className="tw:p-3 tw:flex tw:flex-col tw:h-full tw:min-h-0">
        <div className="tw:flex-1 tw:min-h-0">
          <div className="tw:flex tw:justify-between tw:items-start tw:mb-2">
            <CardHeading className="tw:line-clamp-2">
              <i className="far fa-fw fa-lg fa-envelope tw:mr-1" />
              {invitation.email}
            </CardHeading>
            <span className="tw:block tw:mt-2 tw:text-xs tw:text-zinc-500">
              Invited on {invitedOn}
            </span>
          </div>
          <div className="tw:flex tw:flex-wrap tw:gap-2 tw:mt-2">
            {invitation.group_names?.map((code) => {
              const label = groupNamesMap[code] || code;
              return (
                <span
                  key={code}
                  className="tw:inline-flex tw:items-center tw:px-2 tw:py-0.5 tw:rounded tw:text-xs tw:bg-zinc-100 tw:text-zinc-700"
                >
                  {label}
                </span>
              );
            })}
          </div>
        </div>
        {actions && (
          <div
            className="tw:mt-auto tw:flex tw:gap-1"
            onClick={(e) => e.stopPropagation()}
            role="button"
            tabIndex={0}
            onKeyUp={(e) => {
              if (e.key === ' ' || e.key === 'Enter') {
                e.stopPropagation();
              }
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingInvitationCard;
